import React, { useState, useEffect } from 'react';
import { RefreshCw } from 'lucide-react';

const UPDATED_KEY = 'app_just_updated';
const AUTO_DISMISS_MS = 5000;

const UpdateBanner = () => {
  const [visible, setVisible] = useState(false);
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    try {
      const justUpdated = localStorage.getItem(UPDATED_KEY);
      if (!justUpdated) return;

      // Clear the flag immediately so it only shows once
      localStorage.removeItem(UPDATED_KEY);

      const version = localStorage.getItem('app_version') || '';
      setVisible(version);

      // Auto-dismiss after 5 seconds
      const timer = setTimeout(() => {
        setExiting(true);
        setTimeout(() => setVisible(false), 300);
      }, AUTO_DISMISS_MS);

      return () => clearTimeout(timer);
    } catch {}
  }, []);

  if (!visible) return null;

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-[60] bg-emerald-50 dark:bg-emerald-900/80 border-b border-emerald-200 dark:border-emerald-700 px-4 py-2.5 flex items-center justify-center gap-2 transition-all duration-300 ${exiting ? 'opacity-0 -translate-y-full' : 'opacity-100 translate-y-0'}`}
      role="status"
      aria-live="polite"
    >
      <RefreshCw size={14} className="text-emerald-600 dark:text-emerald-400" />
      <span className="text-sm font-medium text-emerald-800 dark:text-emerald-200">
        App updated to v{visible}
      </span>
    </div>
  );
};

export default UpdateBanner;
